import {HubApiRequest} from '../hub-api-request';
import {HubMethod} from '../constants/methods';
import {v4 as uuidv4} from 'uuid';
import {
    GetTokenByContinuePlayingUrlReq,
    GetTokenByContinuePlayingUrlResponse
} from '../protocol/get-token-by-continue-playing-url-req';

export class GetTokenByContinuePlayingUrl extends HubApiRequest<GetTokenByContinuePlayingUrlReq, GetTokenByContinuePlayingUrlResponse> {
    constructor(url: string, deviceIdentifier: string, data: GetTokenByContinuePlayingUrlReq) {
        super(url, HubMethod.GET_TOKEN_BY_CONTINUE_PLAYING_URL, deviceIdentifier, data, uuidv4());
    }
}
